module.exports = __webpack_public_path__ + "img/i-1.17592ded.svg";